export default {
	settings: {
		basic: {
			buttons: ['bold', 'italic', 'deleted', 'link', 'undo', 'redo', 'source'],
			plugins: [],
		},
		blog: {
			buttons: ['format', 'bold', 'italic', 'deleted', 'link', 'image', 'video', 'lists', 'undo', 'redo'],
			plugins: ['inlinestyle', 'video', 'fullscreen'],
		},
		product: {
			buttons: ['format', 'bold', 'italic', 'deleted', 'link', 'video', 'lists', 'undo', 'redo'],
			plugins: ['video', 'fullscreen'],
		}
	}
};
